<template>
  <div> 
    <b-form-group
      :class="title_position"
      id="gbirimler"
      :label-cols-lg="labels_lg"
      :label="FormDataType.FieldTitle"
      label-for="text"
    >
      
      <AgacMenu
        :class="{ 'is-invalid': v.$error }"
        :multiple="multiple"
        :options="options"
        :flat="false"
        :sort-value-by="sortValueBy"
        :default-expand-level="1"
        placeholder="Birim Seçiniz"
        :clearable="clearable"
        :searchable="searchable"
        :disabled="disabled"
        :open-on-click="openOnClick"
        :open-on-focus="openOnFocus"
        :clear-on-select="clearOnSelect"
        :close-on-select="closeOnSelect"
        :always-open="alwaysOpen"
        :append-to-body="appendToBody"
        :limit="limit"
        :limitText="count => `${count} kayıt secildi`"
        :max-height="200"
        v-model="value"
        :input="$emit('input', value)"
        :rtl="rtl"
        :value-consists-of="valueConsistsOf"
      />
      <treeselect-value :value="value" />

      <div v-if="v.$error" class="invalid-feedback">
        
        <span v-if="v.required == false">{{
          $t("ValidationMessage.required")
        }}</span>
      </div>
 

    </b-form-group>



  </div>

  
</template>

<script>
import AgacMenu from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";


export default {
  components: {
    AgacMenu,
  },
  props: [
    "v",
    "multiple",
    "BirimTipId",
    "FieldTitle",
    "title_position",
    "labels_lg",
    "selected",
    "closeOnSelect",
    "FormDataType",
    "FormPost",
  ],
  data: () => ({
    value: [],
    options: [],
    birimlist: [],
    clearable: true,
    searchable: true,
    disabled: false,
    openOnClick: true,
    openOnFocus: false,
    clearOnSelect: true,
    alwaysOpen: false,
    appendToBody: false,
    sortValueBy: "ORDER_SELECTED", //LEVEL , INDEX
    valueConsistsOf: "ALL", // "BRANCH_PRIORITY", "LEAF_PRIORITY","ALL_WITH_INDETERMINATE"
    rtl: false,
    flat: false,
    limit: 0,
    Page: {
      PageNumber: "1",
      PageSize: "9999",
      PageDataSize: "1",
    },
    InputName: "",
  }),


  whatch: {
    FormPost() {
      this.$v.$touch();
    },
    selected() {

      this.value = this.selected;

    },
  },
  

created() {

this.options=this.FormDataType.ComboDataArray;
this.value = this.selected;
//console.log(JSON.stringify(this.options));
  },
};
</script>

